import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RecaptchaModule } from 'ng-recaptcha';

import { DetachedRouterModule } from '@recruitee/common';
import { RtUIModule } from '@recruitee/user-interface';

import { SharedModule } from '../shared/shared.module';
import { MainViewModule } from './main-view/main-view.module';
import { TitleService } from './services/title.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DetachedRouterModule,
    SharedModule,
    RtUIModule,
    RecaptchaModule,
    MainViewModule,
  ],
})
export class CoreModule {
  constructor(private titleService: TitleService) {}
}
